export const SET_IS_LOADING = "IMPORT_LEADS/SET_IS_LOADING";
export const SET_IMPORT_LEAD_LIST = "IMPORT_LEADS/SET_RESOURCE_LIST";
export const IMPORT_LEAD_LIST_ADD_ITEM =
  "IMPORT_LEADS/IMPORT_LEAD_LIST_ADD_ITEM";
